export const createArrayMinMax = (min, max) => {
  var minimum = Math.round(min),
    maximum = Math.round(max);
  var x = Array.apply(null, { length: maximum + 1 - minimum }).map(function (
    _,
    idx
  ) {
    return idx + min;
  });
  //   console.log(x, "array>>>>");
  return x;
};
